// extracted by mini-css-extract-plugin
export var cardContainer = "AgencyCard-module--card-container--3f5i1";
export var cardShadow = "AgencyCard-module--card-shadow--3FxbA";
export var cardHeader = "AgencyCard-module--card-header--3sTT1";
export var cardContentContainer = "AgencyCard-module--card-content-container--37lZG";
export var agencyLinkStyle = "AgencyCard-module--agency-link-style--3Uft_";